const mapStateToProps = (state) => ({
  dataUsuarioPorAsociar: state.asociarUsuarios.dataUsuarioPorAsociar,
});
export default mapStateToProps;
